import axiosInstance from "../axiosInstance";

export const lostSalesEventsService = {
  list: async () => {
    const response = await axiosInstance.get(
      "/lost-sales-events?$limit=100&$sort[start_date]=1",
    );
    return response.data;
  },
  create: async (event) => {
    const response = await axiosInstance.post("/lost-sales-events", event);
    return response.data;
  },
  patch: async (id, event) => {
    const response = await axiosInstance.patch(`/lost-sales-events/${id}`, event);
    return response.data;
  },
  remove: async (id) => {
    const response = await axiosInstance.delete(`/lost-sales-events/${id}`);
    return response.data;
  },
};
